export const layoutTabReset = {
  ALL: 'all',
  ONLY_COMMUNICATION: 'communication',
  ONLY_DUPLICATE_COMMUNICATION: 'duplicateCommunication',
};
